/* Glowora: swipe-ondersteuning op touchdevices.
 *
 * De transform-gebaseerde sliders in dit thema hebben geen enkele touch-handler:
 * de cart-drawer upsell (assets/cart-upsell.js) en de Lumin Slider
 * (assets/lumin-slider.js, gebruikt door de Instagram-feed en de reviewslider
 * op de productpagina). Je kon dus alleen op pijltjes of bolletjes klikken.
 *
 * Deze file voegt swipe toe zonder iets in die sliders te veranderen: hij
 * detecteert een horizontale veeg en roept dezelfde actie aan die het pijltje
 * ook aanroept. Daardoor blijven autoplay, loop, de bolletjes en de
 * disabled-state van de pijltjes precies zoals ze waren.
 *
 * Event delegation op document, zodat het ook werkt voor sliders die later in
 * de DOM komen (de cart drawer rendert zichzelf opnieuw bij elke wijziging).
 */
(function () {
  'use strict';

  var THRESHOLD = 40; // px die je minimaal moet vegen
  var RATIO = 1.4; // horizontaal moet dit x duidelijker zijn dan verticaal
  var CLICK_GRACE = 500; // ms waarin een klik na een veeg wordt genegeerd
  var TRACKS = '.cart-upsell-slider, .lumin-slider-wrapper';

  var track = null;
  var startX = 0;
  var startY = 0;
  var swipedTrack = null;
  var swipedAt = 0;

  function findTrack(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(TRACKS);
  }

  function advanceCartUpsell(el, direction) {
    var root = el.closest('cart-upsell-component');
    if (!root) return;
    var button = root.querySelector('[data-slider-nav="' + direction + '"]');
    if (button && !button.disabled) button.click();
  }

  function advanceLumin(el, direction) {
    var inner = el.closest('.lumin-slider');
    var slider = inner && inner._luminSlider;
    if (!slider) return;

    // Zelfde volgorde als de klik-handler in lumin-slider.js, zodat de
    // autoplay-timer netjes opnieuw begint na een veeg.
    slider.stopAutoplay();
    if (direction === 'next') {
      slider.slideNext();
    } else {
      slider.slidePrev();
    }
    if (slider.autoplay) slider.startAutoplay();
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      track = null;
      if (event.touches.length !== 1) return;

      var found = findTrack(event.target);
      if (!found) return;

      track = found;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      var el = track;
      track = null;
      if (!el || !event.changedTouches.length) return;

      var deltaX = event.changedTouches[0].clientX - startX;
      var deltaY = event.changedTouches[0].clientY - startY;

      // Verticaal scrollen van de pagina mag nooit als veeg gelden.
      if (Math.abs(deltaX) < THRESHOLD) return;
      if (Math.abs(deltaX) < Math.abs(deltaY) * RATIO) return;

      var direction = deltaX < 0 ? 'next' : 'previous';

      // Onthouden dat er geveegd is: de browser vuurt na een sleep alsnog een
      // click af, en zonder dit navigeer je per ongeluk weg als de slide een
      // link is (bijvoorbeeld de Instagram-feed).
      swipedTrack = el;
      swipedAt = Date.now();

      if (el.classList.contains('cart-upsell-slider')) {
        advanceCartUpsell(el, direction);
      } else {
        advanceLumin(el, direction);
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!swipedTrack) return;

      if (Date.now() - swipedAt > CLICK_GRACE) {
        swipedTrack = null;
        return;
      }

      // Alleen de klik binnen dezelfde slider slikken, niets anders.
      if (findTrack(event.target) !== swipedTrack) return;

      swipedTrack = null;
      event.preventDefault();
      event.stopPropagation();
    },
    true // capture, zodat we voor de link-handler zitten
  );

  document.addEventListener(
    'touchcancel',
    function () {
      track = null;
    },
    { passive: true }
  );
})();
